import {SET_DRAWER_COMPONENT, SET_DRAWER_COMPONENT_TITLE, SET_DRAWER_STATE} from '../store/mutation-types'
import { mapMutations } from 'vuex'

const RightDrawer = {
  methods: {
    ...mapMutations({
      setDrawerState: SET_DRAWER_STATE,
      setDrawerComponent: SET_DRAWER_COMPONENT,
      setDrawerComponentTitle: SET_DRAWER_COMPONENT_TITLE
    })
  }
}

export default RightDrawer



// WEBPACK FOOTER //
// ./src/mixins/RightDrawer.js